import { CheckLibs, DscStorageLib } from "@digital-supply-chain/module";
import { WinForm, DomainService, UtilService, IframePostMessage } from "../libs";
import { CompService } from './comp';
import { AdService } from './ad';
import router from '../router'

export class OpenService {
  
  static openCompNews(CompMdt: String) {
    window.open(`//${CompMdt}.maidiyun.com/news.html?version=1`);
  }

  static openCompDetail(CompID: String) {
    if (this.getRouterTarget() == '_self') {
      window.location.href = this.getCompDetailUrl(CompID);
    } else {
      window.open(this.getCompDetailUrl(CompID));
    }
  }
  static getCompDetailUrl(CompID: String) {
    return `${DomainService.Web}/company/home/${CompID}`;
  }

  static getRouterTarget() {
    if (CheckLibs.isInIframe()) return '_self';
    return '_blank';
  }

  static openProdDetails(ProdID: String, lecto_params: string = '', lecto_value_key: string = '') {
    let url = `/product/detail/${ProdID}?lecto_params=${lecto_params}`;
    lecto_value_key && (url = url + '&lecto_value_key=' + lecto_value_key);

    const {name, type} = DscStorageLib.sessionGet(IframePostMessage.NeIframeAgent);
    if (name == IframePostMessage.NeIframeAgentTianZhun) {
      if (type == IframePostMessage.NeIframeAgentTianZhunPlugin) {
        (window as any).formium.postMessage("OpenProd", location.origin + url);
      }
      if (type == IframePostMessage.NeIframeAgentTianZhunAdmin) {
        window.parent.postMessage({
          key: 'open_prod_detail',
          data: {
            url: location.origin + url
          }
        }, "*");
      }
      return;
    }

    if (this.getRouterTarget() == '_self') {
      window.location.href = url;
    } else {
      window.open(url);
    }
  }
  static getProdDetailUrl(ProdID: String) {
    return `/product/detail/${ProdID}`
  }

  static openSearchLib(keyword: string, openNew: boolean = false, queryString: string = '', type = 'lib') {
    let url = `${DomainService.Web}/search/${type}/${encodeURIComponent(keyword)}${queryString}`;
    if (openNew && this.getRouterTarget() != '_self') {
      window.open(url)
    } else {
      window.location.href = url;
    }
  }
  static getSearchLibUrl(keyword: string, type = 'lib') {
    return `/search/${type}/${encodeURIComponent(keyword)}`;
  }

  //业务数据点击分享
  static openShareBiz(content: string, source: string = "share") {
    WinForm.md.openWindow(`${DomainService.ImWeb}/views/sharepage.html?content=${content}&source=${source}`, 650, 530);
  }

  static notify(categoryId: number, userId: number, message: string) {
    (parent.window as any || window as any).sjb.openTabInChat('sessionChat');

    (parent.window as any || window as any).md.$emit("IMSendMessage", JSON.stringify({
      receivers: [`${categoryId}:${userId}`],
      message: message
    }));
  }


  static previewImg(images: any[], curImg: any) {
    let _index = 0, realW = 0, realH = 0;
    let imgSrcArr: any = [].map.call(images, (img: any, index: number) => {
      if (img === curImg) {
        _index = index;
        realW = img.naturalWidth;
        realH = img.naturalHeight;
      }
      let realSrc = img.getAttribute("props");
      return img.src.replace(/\?x-oss-process=[^=]+$/, "");
    });
    this.openImgPreview(_index, imgSrcArr);
  }

  static openImgPreview(imgIndex: any, imgArr: any = []) {
    imgArr = imgArr.map((item: any) => {
      if (item.indexOf(';base64,') == -1) {
        return item.indexOf('http') != 0 ? 'http:' + item : item;
      } else {
        return item
      }
    });
    WinForm.md.$emit('preview_img', JSON.stringify({
      imgArr,
      imgIndex,
    }))
    WinForm.md.showWindow(`${DomainService.ImWeb}/local_lib/imgviewer.html`);
  }

  static chatCustomer() {//跟客服 聊天
    // WinForm.sjb.openTabInChat('sessionChat');
    // WinForm.md.$emit("IMStart", `${Category.User}:${Administrator.CUSTOMER}`);
  }

  // 购买vip页面
  static openBuyVip(lockOtherWindow=false) {
    // WinForm.md.openWindow(`${location.protocol}${DomainService.Sjb}/views/vipintro.html`, 650, 450);
  }

  /*
  * 发送生产任务单页面
  * @params  type new  新建   edit 编辑   children 子任务
  * */

  static openNewTask(option: any = {}) {
    // let title = option.TaskID ? "编辑任务" : "新建任务";
    // let params = ""
    // for (const key in option) {
    //   params += `&${key.toLowerCase()}=${option[key]}`
    // }
    // params.substr(1);
    // const tabId = UtilService.Guid();
    // const url = `${location.protocol}${DomainService.Pdm}/#/new-task?${params}&tabid=${tabId}`;
    // WinForm.md.openTab(url, title, "", tabId);
  }
  static openTask(id: number, taskname = "任务详情") {
    // const url = `${location.protocol}${DomainService.Pdm}/#/task-detail?tabid=${id}&id=${id}`;
    // WinForm.md.openTab(url, taskname, "", id.toString());
  }

  /**
   * 打开广告地址详情页
   * @param url 
   */
  static openAdvInfo(url: string) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = location.protocol + "//" + url;
    }
    const mdt = url.substring(url.lastIndexOf('//') + 2, url.indexOf('maidiyun') - 1);
    if (mdt) {
      CompService.getSInfo(mdt).then(data => {
        data.CompID && OpenService.openCompDetail(data.CompID);
      })
    } else {
      window.open(url);
    }
  }

  /**
   * 打开广告详情页（新的）
   * @param advId 
   * @param url 
   */
  static openAdvertInfo(advId: string, url: string) {
    const urlConfig = UtilService.getUrlParamObj(url);
    const { type, id } = urlConfig;
    AdService.clickAdverts(advId);
    switch (type) {
      case 'company':
        this.openCompDetail(id);
        break;
    
      default:
        break;
    }
  }
}